function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HoldersTemplate = require('./holders.template');
var _require = require('../peer/client'),
  sendExplorerPeerRequest = _require.sendExplorerPeerRequest;
function normalizePage(value) {
  return /^[1-9]\d*$/.test(String(value)) && Number.isSafeInteger(Number(value)) ? Number(value) : 1;
}
var Holders = /*#__PURE__*/function () {
  function Holders(app, mod) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var snapshotId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck(this, Holders);
    this.app = app;
    this.mod = mod;
    this.page = normalizePage(page);
    this.snapshotId = snapshotId;
    this.container = '.explorer-view';
    this.view = null;
    this.loading = false;
    this.error = null;
    this.expired = false;
    this.loadToken = 0;
    this.timer = null;
  }
  return _createClass(Holders, [{
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) this.container = container;
      this.load();
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      this.loadToken++;
      clearTimeout(this.timer);
    }
  }, {
    key: "load",
    value: function load() {
      var _this = this;
      this.cleanup();
      var token = this.loadToken;
      this.loading = true;
      this.error = null;
      this.expired = false;
      this.paint();
      var peer = this.mod.explorerPeer;
      if (!peer) return; // onPeerServiceUp restarts this view once connected.

      var finished = false;
      var finish = function finish(response) {
        if (finished || token !== _this.loadToken || _this.mod.activeView !== 'holders') return;
        finished = true;
        clearTimeout(_this.timer);
        _this.loading = false;
        if (response !== null && response !== void 0 && response.err || !(response !== null && response !== void 0 && response.success) || !(response !== null && response !== void 0 && response.data)) {
          _this.error = (response === null || response === void 0 ? void 0 : response.error) || 'Unable to load holders. Please retry.';
          _this.expired = (response === null || response === void 0 ? void 0 : response.code) === 'SNAPSHOT_EXPIRED';
        } else {
          _this.view = response.data;
          _this.page = _this.view.page;
          _this.snapshotId = _this.view.snapshot_id;
          window.history.replaceState({
            view: 'holders',
            page: _this.page,
            snapshotId: _this.snapshotId
          }, '', "/".concat(_this.mod.slug, "/holders?page=").concat(_this.page));
        }
        _this.paint();
      };
      this.timer = setTimeout(function () {
        return finish({
          error: 'The holder request timed out. Please retry.'
        });
      }, 20000);
      try {
        var request = sendExplorerPeerRequest(this.app, 'request holders', {
          data: {
            request: 'request holders',
            page: this.page,
            snapshot_id: this.snapshotId
          },
          peer: peer,
          callback: finish
        });
        Promise.resolve(request)["catch"](function () {
          return finish({
            error: 'Unable to contact the Explorer peer. Please retry.'
          });
        });
      } catch (err) {
        finish({
          error: 'Unable to contact the Explorer peer. Please retry.'
        });
      }
    }
  }, {
    key: "paint",
    value: function paint() {
      var _this2 = this;
      this.app.browser.replaceElementContentBySelector(HoldersTemplate(this.app, {
        view: this.view,
        loading: this.loading,
        waiting: !this.mod.explorerPeer,
        error: this.error,
        expired: this.expired
      }), this.container);
      var root = document.querySelector(this.container);
      if (!root) return;
      root.querySelectorAll('[data-holders-page]').forEach(function (button) {
        button.onclick = function () {
          return _this2.mod.renderHolders({
            page: Number(button.dataset.holdersPage),
            snapshotId: _this2.snapshotId,
            animate: false
          });
        };
      });
      var refresh = root.querySelector('[data-holders-refresh]');
      if (refresh) refresh.onclick = function () {
        return _this2.mod.renderHolders({
          page: 1,
          animate: false
        });
      };
      var retry = root.querySelector('[data-holders-retry]');
      if (retry) retry.onclick = function () {
        return _this2.load();
      };
    }
  }]);
}();
module.exports = Holders;
module.exports.normalizePage = normalizePage;